import {fetchAllOrganizationListApi, UserLogListRequest} from 'api/salesApi'
import {useQuery} from 'react-query'

export default function useSalesAllOrgFetch(query: UserLogListRequest) {
  return useQuery(['fetchOrganizationList', query], () =>
    fetchAllOrganizationListApi(query),
  )
}
